export default __webpack_public_path__ + "static/media/com-icon.658a9726.svg";